@import '@hevoio/hevo-ui-toolkit/styles/variables';

.sqlViewer {
  background-color: $surface-bg;
  border-radius: $border-radius-md;
  border: solid $border-width $divider-color;
  height: 200px;
}

.sqlViewerCodeEditorWithoutLineNumber {
  padding: $spacer * .75;
}
